import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { STORAGE_SETTING } from '@app/constants/local-storage-setting';
import { REQUEST_METHODS } from '@app/constants/request-methods';
import { IPowerBiReport } from '@app/types/power-bi-report';
import { IUserCompanyDetails } from '@app/types/user-company-details';
import { RequestBuilderService } from '../request-builder/request-builder.service';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    private requestBuilderService = inject(RequestBuilderService);

    validateUser() {
        let headers: HttpHeaders | null = null;
        if (localStorage.getItem(STORAGE_SETTING.bpTkn)) {
            headers = new HttpHeaders({
                'X-Accept-Invitation': localStorage.getItem(STORAGE_SETTING.bpTkn) ?? '',
            });
            //remove the storage after use
            localStorage.removeItem(STORAGE_SETTING.bpTkn);
        }
        return this.requestBuilderService.post<boolean>(
            REQUEST_METHODS.V1.Users.Validate,
            null,
            null,
            headers,
        );
    }

    getUserCompanyDetails(mdmId: string) {
        return this.requestBuilderService.get<IUserCompanyDetails>(
            REQUEST_METHODS.V1.Users.CompanyDetails(mdmId),
        );
    }
    getCompanyLogo(mdmId: string, fileName: string) {
        return this.requestBuilderService.getImg<Blob>(
            REQUEST_METHODS.V1.Companies.CompanyLogo(mdmId, fileName),
        );
    }

    getPowerBiReport(id: string) {
        return this.requestBuilderService.get<IPowerBiReport>(
            REQUEST_METHODS.V1.Analytics.GetPowerBiReport(id),
        );
    }
}
